import React from 'react';

const launchHighlights = [
  {
    title: 'Swipeable civic feed',
    description: 'Follow major legislation with concise summaries and a faster path to understanding.',
  },
  {
    title: 'Representative outreach',
    description: 'Turn your position into action with guided messaging for the officials who represent you.',
  },
  {
    title: 'Private preview rollout',
    description: 'Public access is paused while we finish the next release and prepare the first invited launch.',
  },
];

function ComingSoon() {
  return (
    <main className="coming-soon-page">
      <section className="coming-soon-shell">
        <span className="coming-soon-badge">Private preview</span>
        <h1>CivicSwipe is coming soon.</h1>
        <p className="coming-soon-lead">
          We are building a simpler way to follow legislation, understand what it means,
          and take action without the usual friction.
        </p>

        <div className="coming-soon-status">
          <div className="coming-soon-status-card">
            <span className="coming-soon-label">Status</span>
            <strong>Under construction</strong>
          </div>
          <div className="coming-soon-status-card">
            <span className="coming-soon-label">Access</span>
            <strong>Limited and private</strong>
          </div>
        </div>

        <div className="coming-soon-grid">
          {launchHighlights.map((item) => (
            <article key={item.title} className="coming-soon-card">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
            </article>
          ))}
        </div>

        <p className="coming-soon-note">
          Thank you for your patience while we finish the experience and prepare the public launch.
        </p>
      </section>
    </main>
  );
}

export default ComingSoon;
